import {Injectable} from '@angular/core';
import {AuthInfoDTO} from "../../core/dto/AuthInfoDTO";
import {AuthenticationService} from "./Authentication.service";

@Injectable()
export class CookieService {
  cookieName = "BILGEBOT_TOKEN";
  headerToken = "";

  constructor() { }


  public getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    // let ca: Array<string> = this.exampleCookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return null;
  }

  public deleteCookie(name: string) {
    localStorage.removeItem('activeUser');
    //tüm çerezleri sil
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      document.cookie = name + "=;  domain=.bilgebot.ai; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    });
    window.globalActiveUser=null;
  }

  public getUserInfo(cookieName: string):AuthInfoDTO{
    let authInfo: AuthInfoDTO= new AuthInfoDTO();
    let cookie = this.getCookie(cookieName);
    if (cookie && cookie != "") {
      let authJson = this.parseJwt(cookie);
      if(authJson){
        authInfo = new AuthInfoDTO();
        authInfo.firstName = authJson["given_name"];
        authInfo.lastName = authJson["family_name"];
        authInfo.email = authJson["email"];
        authInfo.userId = authJson["sub"];
        authInfo.fullName = authJson["name"];
      }
    }

    return authInfo;
  }

  parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

}
